import {
    AUTH_ERROR,
    AUTH_LOGIN,
    AUTH_LOGOUT,
} from "../../types";

// Initial state
const initialState = {
    loading: false,
    isAuthenticated: false,
    user: null,
    error: null,
    accessToken: null,
    refreshToken: null
};

// Auth reducer
export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_LOGIN:
            return {
                ...state,
                loading: false,
                isAuthenticated: true,
                user: action.payload.user,
                accessToken: action.payload.access_token,
                refreshToken: action.payload.refresh_token,
                error: null
            };

        case AUTH_ERROR:
            return {
                ...state,
                loading: false,
                isAuthenticated: false,
                error: action.payload
            };

        case AUTH_LOGOUT:
            return {
                ...initialState
            };

        default:
            return state;
    }
};

export default authReducer; 